import { Subject } from 'rxjs';
import { ConditionType, EditorFilter, FilterCondition, EditorFilterTreeNode, FilterType } from './filter-administration.model';

export class FilterContextChange {

    source: string;
    key: string;
    value: any;

    constructor(source: string, key: string, value?: any) {
        this.source = source;
        this.key = key;
        this.value = value;
    }
}

export class FilterAdministrationContext {

    nextTransientId = -1;

    contextChange$ = new Subject<FilterContextChange>();

    private filter: EditorFilter;
    private filterType = FilterType.TRANSPORT_LIST;

    private draggedConditionTypeAdd: ConditionType;
    private draggedFilterCondition: FilterCondition;

    private selectedFilterCondition: FilterCondition;
    private selectedFilterNode: EditorFilterTreeNode;

    public setFilter(filter: EditorFilter, source: string) {
        this.filter = filter;
        this.reset(source);
        this.contextChange$.next(new FilterContextChange(source, 'filter-changed', this.filter));
    }

    public getFilter() {
        return this.filter;
    }

    public setFilterType(filterType: FilterType, source: string) {
        this.filterType = filterType;
        this.contextChange$.next(new FilterContextChange(source, 'filter-type-changed', this.filterType));
    }

    public getFilterType() {
        return this.filterType;
    }

    public setDraggedConditionTypeAdd(conditionType: ConditionType, source: string) {
        this.draggedConditionTypeAdd = conditionType;
        this.contextChange$.next(new FilterContextChange(source, 'dragged-condition-type', this.draggedConditionTypeAdd));
    }

    public setDraggedFilterCondition(draggedFilterCondition: FilterCondition, source: string) {
        this.draggedFilterCondition = draggedFilterCondition;
        this.contextChange$.next(new FilterContextChange(source, 'dragged-filter-condition', this.draggedFilterCondition));
    }

    public setSelectedFilterCondition(selectedFilterCondition: FilterCondition, source: string) {
        this.selectedFilterCondition = selectedFilterCondition;
        this.contextChange$.next(new FilterContextChange(source, 'selected-filter-condition-changed', this.selectedFilterCondition));
    }

    public getSelectedFilterTreeNode() {
        return this.selectedFilterNode;
    }

    public getSelectedFilterCondition() {
        return this.selectedFilterCondition;
    }

    public setSelectedFilterTreeNoe(selectedFilterNode: EditorFilterTreeNode, source: string) {
        this.selectedFilterNode = selectedFilterNode;
        this.contextChange$.next(new FilterContextChange(source, 'selected-filter-node-changed', this.selectedFilterNode));
    }

    private reset(source: string) {
        this.setDraggedConditionTypeAdd(null, source);
        this.setDraggedFilterCondition(null, source);
        this.setSelectedFilterCondition(null, source);
    }

    public getNextTransientId() {
        return this.nextTransientId--;
    }
}
